import {Modal} from "flowbite-react";
import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {clearButtonProcessing, resetAlert, setAlertSuccess, setButtonProcessing} from "../../store/actions";
import {ErrorMessageAlert,Button} from "../../components";
import {errorStatusHandle, getAlertErrorMessage, getFormErrorResponseData} from "../../utils";
import {updateInspections} from "../../api/inspetionItemApi";
import InspectionForm from "./InspectionForm";

function ModalUpdateInspection({ openModal, setOpenModal, modalData, setNewRow }) {
  const dispatch = useDispatch();
  const [inputs, setInputs] = useState(modalData);
  const [errorMessages, setErrorMessages] = useState({});

  const getDefaultIntegerInput = (value) => {
    if (value === undefined || value === null) {
      return '';
    }
    if (value === 0) {
      return '0';
    }
    return value.toString();
  }

  const initialInputs = {
    inspection_item_type: modalData.inspection_item_type.name || "input",
    title: modalData.title || "",
    title_color: modalData.title_color || "",
    description: modalData.description || "",
    description_color: modalData.description_color || "",
    has_value_limit: modalData.inspection_judgment.has_value_limit === true ? "yes" : "no",
    upper_value: modalData.inspection_judgment.upper_value || "",
    upper_boundary_type: getDefaultIntegerInput(modalData?.inspection_judgment.upper_boundary_type),
    lower_value: modalData.inspection_judgment.lower_value || "",
    lower_boundary_type: getDefaultIntegerInput(modalData?.inspection_judgment.lower_boundary_type),
    unit: modalData.unit || "",
    integer_length: getDefaultIntegerInput(modalData?.inspection_judgment.integer_length),
    decimal_length: getDefaultIntegerInput(modalData?.inspection_judgment.decimal_length),
    remark_text: modalData.remark_text,
    is_using: modalData.is_using,
    has_unit: modalData.has_unit,
    input_value_type: modalData.inspection_judgment.input_value_type || 1,
    max_string_length: modalData.inspection_judgment.max_string_length || '',
  }
  useEffect(() => {
    setInputs(initialInputs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalData]);

  // Function to handle closing modal
  const handleClose = () => {
    setInputs(initialInputs);
    setErrorMessages({});
    setOpenModal(false);
  };

  // Function to handle add new inspection item
  const handleUpdateInspection = async (e, buttonId) => {
    e.preventDefault();
    dispatch(resetAlert());
    dispatch(setButtonProcessing(buttonId));
    await updateInspections(inputs, modalData.id).then(
      (response) => {
        setErrorMessages({});
        dispatch(setAlertSuccess(response.message));
        setNewRow(response.data.inspection_item)
        setOpenModal(false);
      }
    ).catch(e => {
      errorStatusHandle(e.response);
      if (e.response.status === 400) {
        let errorResponse = getFormErrorResponseData(e);
        if (errorResponse) {
          setErrorMessages(errorResponse);
        }
      }
    }).finally(() => {
      dispatch(clearButtonProcessing(buttonId));
    });
  };

  return (
    <Modal show={openModal} onClose={() => handleClose()} size="4xl">
      <Modal.Header>プロパティ</Modal.Header>
      <Modal.Body className="p-[20px] bg-[#F2F4F7]">

        <ErrorMessageAlert className="mb-[16px]" error={getAlertErrorMessage(errorMessages)} />
        <InspectionForm setInputs={setInputs} modalData={modalData} errorMessages={errorMessages} />

      </Modal.Body>
      <Modal.Footer className="space-x-[32px]">
        <div className="w-1/2">
          <Button color="light" className="w-full" onClick={() => handleClose()}>
            閉じる
          </Button>
        </div>
        <div className="w-1/2">
          <Button color="primary" className="w-full" onClick={(e) => handleUpdateInspection(e, 'update-inspection-item')} id='update-inspection-item'>
            更新
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalUpdateInspection;